
interface PricingTabsProps {
  activeTab: 'solar' | 'agriculture' | 'roof';
  onTabChange: (tab: 'solar' | 'agriculture' | 'roof') => void;
}

export default function PricingTabs({ activeTab, onTabChange }: PricingTabsProps) {
  const tabs = [
    { id: 'solar' as const, label: 'Solar Farm Inspections', icon: 'ri-sun-line' },
    { id: 'agriculture' as const, label: 'Agriculture Drone Services', icon: 'ri-plant-line' },
    { id: 'roof' as const, label: 'Roof / Property Inspections', icon: 'ri-home-4-line' },
  ];

  return (
    <div className="border-b border-stone-300">
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-0">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex items-center justify-center gap-2 px-6 py-4 text-base font-medium transition-colors whitespace-nowrap
              ${activeTab === tab.id
                ? 'text-emerald-700 border-b-2 border-emerald-700 bg-white'
                : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
              }
            `}
          >
            <i className={`${tab.icon} text-lg`}></i>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
